import { render, staticRenderFns } from "./CurrentUser.vue?vue&type=template&id=699d395e&"
import script from "./CurrentUser.vue?vue&type=script&lang=js&"
export * from "./CurrentUser.vue?vue&type=script&lang=js&"
import style0 from "./CurrentUser.vue?vue&type=style&index=0&id=699d395e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports